import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/d6212764e2e22a594116bb5aaa2c701d/eb3998762c01c8d15a4dc1495ea52480.png" 
              alt="Aeroscan360 Logo" 
              className="h-12 w-auto mb-4 cursor-pointer"
              onClick={() => navigate('/')}
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Ihr zuverlässiger Partner für professionelle Drohnen-Dienstleistungen in Deutschland. 
              Hochpräzise Vermessungen, Such- und Rettungsaktionen sowie Photovoltaik-Inspektionen.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Startseite
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Dienstleistungen
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line text-teal-400 mr-3"></i>
                <span className="text-gray-300">+49 (0) 176 43810216</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-teal-400 mr-3"></i>
                <span className="text-gray-300">info@aeroscan360.de</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line text-teal-400 mr-3"></i>
                <span className="text-gray-300">Rote Gasse 7, 72336 Balingen</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-teal-400 mr-3"></i>
                <span className="text-gray-300">24/7 Notfall-Service</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Aeroscan360. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <button 
                onClick={() => navigate('/datenschutz')}
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Datenschutz
              </button>
              <button 
                onClick={() => navigate('/impressum')}
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Impressum
              </button>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
